<template>
    <panel-template>
        <template #content>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    Dashboard
                </template>
            </ui-breadcrumbs>

            <div class="content-dashboard">
                <div class="container-dashboard">
                    <section class="header">
                        <header-dashboard />
                    </section>

                    <section class="body">
                        <content-dashboard />
                    </section>

                    <section class="footer">
                        <footer-dashboard />
                    </section>
                </div>
            </div>
        </template>
    </panel-template>
</template>

<script>
	import PanelTemplate from '@/templates/page-dashboard'
	import { uiBreadcrumbs } from '@/components/ui'

	import headerDashboard from './components/headerDashboard'
	import footerDashboard from './components/footerDashboard'
	import contentDashboard from './components/contentDashboard'

	export default {
		name: 'dashboard-managers',
		components: {
			PanelTemplate,
			headerDashboard,
			footerDashboard,
			contentDashboard,
			uiBreadcrumbs
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
